/**
 * created by cc 2016-4-13 网站导读图片上传指令
 */

'use strict';
angular.module('editingCenter.imgUploadChg', ['trsUploadFullServiceModule']).directive('trsUploadFull', [
    '$timeout',
    '$stateParams',
    'editPictureService',
    'trsUploadFullService',
    'trsHttpService',
    'trsEditImgService',
    'modalDialog',
    function($timeout, $stateParams, editPictureService, trsUploadFullService, trsHttpService, trsEditImgService, modalDialog) {
        return {
            restrict: 'EA',
            replace: true,
            transclude: true,
            scope: {
                fileName: '=',
                fileDesc: '=',
                returnFile: '=',
                relationId: '=',
                meiziId: '=',
                scaleimgCallback: '&',
                callback: '&',
                maxSize: '@',
                imgIndex: '=',
                clickCallback: '&', // 用于判断是否进行了图片上传
                isFusionEditor: '=', // 是否在融合编辑器
                isShowPersonalMaterial: '=',
                ratio: '=', // 图片的比例
                isAllowGif: '=' // 判断是否允许添加gif图，目前封面图不允许
            },

            templateUrl: './components/util/trsImageUpload/uploaderFull.html',
            link: function(scope, element, attr) {
                initStatus();
                if (scope.ratio && scope.returnFile) {
                    getImgSize();
                }

                /**
                 * [initStatus description]初始化
                 * @return {[type]}        [description]
                 */
                function initStatus() {
                    scope.status = {
                        directcropper: false,
                        isFusionEditor: !!scope.isFusionEditor,
                        isShowPersonalMaterial: !!scope.isShowPersonalMaterial,
                        isAllowGif: angular.isDefined(scope.isAllowGif) ? scope.isAllowGif : true // 默认为true
                    };
                    if (attr.$attr.directcropper) {
                        scope.status.directcropper = true;
                        $timeout(function() {
                            scope.status.picturesize = attr.picturesize;
                        }, 200);
                    }
                }

                /**
                 * [getImgSize description]获得图片尺寸
                 * @return  {[type]}  [return description]
                 */
                function getImgSize() {
                    var img = new Image();
                    img.src = scope.returnFile;
                    if (img.complete) {
                        scope.ratio = (img.width / img.height).toFixed(2);
                    } else {
                        img.onload = function() {
                            scope.ratio = (img.width / img.height).toFixed(2);
                        };
                    }
                }
                scope.openUploadModal = function(reupload) {
                    scope.reupload = reupload != undefined;
                    trsUploadFullService.fullImageUpload(
                        scope.status.isShowPersonalMaterial,
                        scope.maxSize,
                        !(scope.status.directcropper && !scope.status.isFusionEditor),
                        function(data) {
                            element.find('input').val(''); // 上传成功，将file input框清空，不妨碍下一次上传 input框change事件的触发
                            scope.fileNameBak = angular.copy(scope.fileName); // 用于取消裁剪后的回退操作
                            scope.returnFileBak = angular.copy(scope.returnFile); // 用于取消裁剪后的回退操作
                            scope.fileDescBak = angular.copy(scope.fileDesc); // 用于取消裁剪后的回退操作
                            scope.fileBack = angular.copy(scope.file); // 用于取消裁剪后的回退操作
                            scope.relationIdBack = angular.copy(scope.relationId);
                            scope.meiziIdBack = angular.copy(scope.meiziId);
                            scope.isAddPersonalMaterial = data.isAddPersonalMaterial;
                            // if (scope.status.directcropper && !scope.status.isFusionEditor) {
                            //     newCropperApp(data.data.src);
                            //     scope.fileData = data.data;
                            // }
                            // 为了让融合编辑器的图片也有裁剪的功能
                            var isGif = editPictureService.isGif(data.data.src.imgSrc);
                            if (!scope.status.isAllowGif && isGif) {
                                modalDialog.alertType('', 'GIF格式图片无法添加为封面图', 'warning', false);
                                return;
                            }
                            if (scope.status.directcropper && attr.picturesize !== '') {
                                if (!isGif) {
                                    newCropperApp(data.data.src);
                                    scope.fileData = data.data;
                                    $timeout(function() {
                                        successHandle(data.data.src, data.data.file, data.data.resource);
                                    });
                                } else {
                                    var img = new Image();
                                    img.src = data.data.src.imgSrc;
                                    var preSizeArr = attr.picturesize.split(',');
                                    if (img.complet) {
                                        var imgSize = (img.width / img.height).toFixed(2);
                                        if (imgSize !== (preSizeArr[0] / preSizeArr[1]).toFixed(2)) {
                                            modalDialog.alertType('', 'GIF格式图片不支持编辑，当前图片比例与预设比例不同，设为列表图/焦点图会出现变形，是否确定继续？', 'warning', true, function() {
                                                $timeout(function() {
                                                    successHandle(data.data.src, data.data.file, data.data.resource);
                                                });
                                            });
                                        } else {
                                            $timeout(function() {
                                                successHandle(data.data.src, data.data.file, data.data.resource);
                                            });
                                        }
                                    } else {
                                        img.onload = function() {
                                            var imgSize = (img.width / img.height).toFixed(2);
                                            if (imgSize !== (preSizeArr[0] / preSizeArr[1]).toFixed(2)) {
                                                modalDialog.alertType('', 'GIF格式图片不支持编辑，当前图片比例与预设比例不同，设为列表图/焦点图会出现变形，是否确定继续？', 'warning', true, function() {
                                                    $timeout(function() {
                                                        successHandle(data.data.src, data.data.file, data.data.resource);
                                                    });
                                                });
                                            } else {
                                                $timeout(function() {
                                                    successHandle(data.data.src, data.data.file, data.data.resource);
                                                });
                                            }
                                        };
                                    }
                                }
                            } else {
                                $timeout(function() {
                                    successHandle(data.data.src, data.data.file, data.data.resource);
                                });
                            }
                        }
                    );
                };

                /**
                 * [newCropperApp description] APP渠道图片编辑方法
                 * @param  {[type]} src [description] 图片名称和图片地址对象
                 * @param {[type]} [editAgain] [description] 再次编辑
                 * @return {[type]}         [description]
                 */
                function newCropperApp(src, editAgain) {
                    editPictureService.newCropperApp(src, scope.status.picturesize).then(
                    // const _params = {
                    //     image: {
                    //         PERPICURL: src.imgSrc,
                    //         APPFILE: src.imgName
                    //     },
                    //     siteId: $stateParams.wzsiteid || $stateParams.appsiteid,
                    //     channelId: '',
                    //     cropperOption: {},             // cropper 配置项
                    // }
                    // trsEditImgService.editImg(_params).then(
                        function(_src) {
                            successHandle(_src);
                            // isSavePersonal(_src); // 保存至个人素材对接媒资库后不再这里处理，在点击弹窗的去顶按钮之后保存至跟人素材
                            if (!scope.scaleimgCallback()) {
                                return;
                            }
                            scope.scaleimgCallback()(_src, scope.imgIndex);
                        },
                        function() {
                            // 关闭裁剪框的回调
                            if (!editAgain) {
                                cancelHandle();
                            }
                        }
                    );
                }

                /**
                 * [isSavePersonal description]是否储存到个人素材
                 *
                 * @param   {[type]}  _src  [_src description]
                 *
                 * @return  {[type]}        [return description]
                 */
                function isSavePersonal(_src) {
                    if (scope.isAddPersonalMaterial == true && scope.isShowPersonalMaterial) {
                        let picArr = new Array();
                        picArr.push({
                            fileDesc: scope.fileData.src.imgDesc,
                            PersonalMaterialId: '0',
                            fileSize: JSON.stringify(parseInt(scope.fileData.file.size)),
                            fileName: _src.imgName,
                        });
                        var params = {
                            methodname: 'addPersonalMaterialOfImgs',
                            serviceid: 'mlf_releaseSource',
                            PersonalMaterialOfImgs: JSON.stringify(picArr),
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {});
                    }
                }

                /**
                 * [newCropperApp description] APP渠道图片再编辑
                 * @return {[type]} [description]
                 */
                scope.newCropperApp = function() {
                    newCropperApp(scope.fileName, true);
                };

                /**
                 * [removeImg description]删除导读图片框
                 * @return {[type]} [description]
                 */
                scope.removeImg = function() {
                    scope.uploaderSuccess = false;
                    scope.callback();
                };

                /**
                 * [successHandle description]上传图片并且成功过后的处理
                 *
                 * @param   {[type]}  src   [src description]
                 * @param   {[type]}  file  [file description]
                 * @param   {[type]}  resource  [file description]
                 *
                 * @return  {[type]}        [return description]
                 */
                function successHandle(src, file, resource) {
                    scope.fileName = src.imgName;
                    scope.fileDesc = src.imgName;
                    scope.uploaderSuccess = true;
                    scope.returnFile = src.imgSrc;
                    if (resource) {
                        scope.meiziId = resource.meiziId;
                        scope.relationId = resource.relationId;
                    }
                    if (scope.status.picturesize){
                        scope.ratio = (scope.status.picturesize.split(',')[0] / scope.status.picturesize.split(',')[1]).toFixed(2);
                    }
                    if (scope.reupload) {
                        return;
                    }
                    scope.clickCallback(); // 上传成功触发网站导读图片的uploadImg方法
                }

                /**
                 * [cancelHandle description]取消裁剪图片的处理
                 *
                 * @param   {[type]}  src   [src description]
                 * @param   {[type]}  file  [file description]
                 *
                 * @return  {[type]}        [return description]
                 */
                function cancelHandle(src, file) {
                    element.find('input').val(''); // 上传取消，将file input框清空，不妨碍下一次上传 input框change事件的触发
                    scope.fileName = angular.copy(scope.fileNameBak);
                    scope.returnFile = angular.copy(scope.returnFileBak);
                    scope.fileDesc = angular.copy(scope.fileDescBak);
                    scope.relationId = angular.copy(scope.relationIdBack);
                    scope.meiziId = angular.copy(scope.meiziIdBack);
                    scope.uploaderSuccess = false;
                }

                /**
                 * [modifyImg description]图片修改
                 * @return {[type]} [description]
                 */
                scope.modifyImg = function() {
                    var siteId = $stateParams.wzsiteid || $stateParams.appsiteid;
                    editPictureService.editPicture({ PERPICURL: scope.returnFile, APPFILE: scope.fileName }, siteId, function(img) {
                        var myImg = new Image();
                        var sFileName = img.imgName || img.FN;
                        var imageUrl = '/wcm/file/read_image.jsp?FileName=' + sFileName; // 文件没有保存之后，是U0开头

                        if (sFileName.match(/^W0/)) {
                            imageUrl = ['/webpic/', sFileName.substring(0, 8), '/', sFileName.substring(0, 10), '/', sFileName].join('');
                        }
                        myImg.src = imageUrl;
                        myImg.onload = function() {
                            scope.fileName = img.imgName;
                            scope.returnFile = imageUrl;
                            scope.$apply();
                        };
                    });
                };

                /**
                 * [cropper description]只裁剪图片
                 * @return {[type]} [description]
                 */
                scope.cropper = function() {
                    var src = {
                        imgSrc: scope.returnFile,
                    };
                    editPictureService.cutPicture(src, scope.status.picturesize, function(_src) {
                        var file = {
                            ext: '',
                        };
                        var picturesizeArray = scope.status.picturesize.split(',');
                        var width = picturesizeArray[0];
                        var height = picturesizeArray[1];
                        editPictureService.compressImg(_src.imgSrc, Math.round(width), Math.round(height)).then(function(__src) {
                            var __srcArray = __src.split('=');
                            var srcObj = {
                                imgName: __srcArray[__srcArray.length - 1],
                                imgSrc: __src,
                                success: '上传成功',
                            };
                            successHandle(srcObj, file);
                        });
                        // successHandle(_src, file);
                    });
                };

                scope.isGif = function() {
                    return editPictureService.isGif(scope.returnFile);
                };
            },
        };
    },
]);
